import { createFileRoute } from "@tanstack/react-router";

import { ChatModerationPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/chat")({
  component: ChatModerationPage,
});
